import { render, staticRenderFns } from "./orderTabTwo.vue?vue&type=template&id=9e22f18e"
import script from "./orderTabTwo.vue?vue&type=script&lang=js"
export * from "./orderTabTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports